import PropTypes from 'prop-types';
import { useRef } from 'react';
import { connect } from 'react-redux';
import { Button, Icon } from '@bwoty-web/ui-kit';
import { UI_SORT_DESCENDING } from '@bwoty-web/ui-kit/icons';
import { bindActionCreators } from 'redux';
import { useIsGlobetrotter, useIsMobile, useOnClickOutside } from '@bwoty-web/ui-kit/hooks';

import SortPanel from '../shared/sortPanel/SortPanel';

import * as CruiseListActions from '../../redux/actions/cruiseListActions';

import './cruiseSortPanel.scss';

const CruiseSortPanel = ({
  actions,
  isInspiration,
  labels,
  selectedSortOrder,
  sortOptions,
  sortPanelIsVisible,
}) => {
  const wrapperRef = useRef(null);
  const isGlobe = useIsGlobetrotter();
  const isMobile = useIsMobile();
  const enableClickOutSide = sortPanelIsVisible && !isMobile;
  const closeSortPanel = () => actions.toggleSortPanel(false);
  const sortBtnElement = document.getElementById('iw-cruise-list__sort-button');
  useOnClickOutside(wrapperRef, closeSortPanel, enableClickOutSide, false, [
    sortBtnElement,
  ]);

  const sortBtnProps = { ...(isMobile && { 'aria-haspopup': 'dialog' }) };
  return (
    !isInspiration && (
      <div className="iw-cruise-list__sort-container">
        <Button
          className="iw-cruise-list__sort-btn"
          id="iw-cruise-list__sort-button"
          onClick={() => actions.toggleSortPanel(!sortPanelIsVisible)}
          variant={isGlobe ? 'secondary' : 'secondary-dark'}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...sortBtnProps}
        >
          <Icon alt="" path={UI_SORT_DESCENDING} size="xs" sizeMobile="xs" />
          {labels.sortBtnLabel}
        </Button>
        <SortPanel
          closeSortPanel={closeSortPanel}
          isMobile={isMobile}
          selectedSortOrder={selectedSortOrder}
          sortAction={actions.sortCruiseList}
          sortOptions={sortOptions}
          sortPanelIsVisible={sortPanelIsVisible}
          wrapperRef={wrapperRef}
        />
      </div>
    )
  );
};

CruiseSortPanel.propTypes = {
  actions: PropTypes.shape({
    sortCruiseList: PropTypes.func.isRequired,
    toggleSortPanel: PropTypes.func.isRequired,
  }).isRequired,
  isInspiration: PropTypes.bool.isRequired,
  labels: PropTypes.shape({ sortBtnLabel: PropTypes.string.isRequired })
    .isRequired,
  selectedSortOrder: PropTypes.string.isRequired,
  sortOptions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  sortPanelIsVisible: PropTypes.bool.isRequired,
};

function mapActions(dispatch) {
  return {
    actions: bindActionCreators({ ...CruiseListActions }, dispatch),
  };
}

function mapStateToProps(state) {
  const newState = state.toJS();
  const { isInspiration } = newState.common.siteSettings;

  return {
    isInspiration,
    labels: newState.labels,
    selectedSortOrder: newState.sort.selected,
    sortOptions: newState.sort.sortOptions,
    sortPanelIsVisible: newState.sort.sortPanelIsVisible,
  };
}

export default connect(mapStateToProps, mapActions)(CruiseSortPanel);
